import React, { useState } from "react";
import { observer } from "mobx-react-lite";

import { debounce, DebounceCounter } from "src/common/debounce";
import { PlmInputSearch } from "src/components/PlmInputSearch";
import { SchedulingControlStore } from "../../../SchedulingControlStore";

const debounceCounter: DebounceCounter = {};

interface PropsTaskSearch {
  store: SchedulingControlStore;
}

export const TaskSearch: React.FC<PropsTaskSearch> = observer(({ store }) => {
  const { searchQuery } = store;
  const [query, setQuery] = useState(searchQuery);
  return (
    <PlmInputSearch
      value={query}
      onChange={(e) => {
        setQuery(e.target.value);
        debounce(debounceCounter, 300, () => {
          store.setSearchQuery(e.target.value);
        });
      }}
    />
  );
});
